export enum KeyNavigationEnum {
  ArrowRight = 'right',
  ArrowLeft = 'left',
  ArrowUp = 'up',
  ArrowDown = 'down',
}
